// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyPads_container__3TzSr","key":"KeyPads_key__EdAr-"};